import React, { useState } from "react";
import { personFullname } from "../../utils/personUtils";
import {
    Page,
    PageHeader,
    CardTitle,
    Row,
    Col,
    Text,
    Callout,
    Card,
    CardContent,
    ItemList,
    Spinner,
    Badge,
    Paragraph,
    Icon
} from "@tv2no/ui-react";
import { taxSearch } from "../../api/services/taxSearch";
import { PersonSearchForm } from "../../components/form/PersonSearchForm";

export const PersonSearch = () => {
    const [busySearching, setBusySearching] = useState(false);
    const [errorSearching, setErrorSearching] = useState(false);
    const [searchResult, setSearchResult] = useState(null);

    const handleSearch = ({ year, size, firstName, middleName, lastName, birthYear }) => {
        setErrorSearching(false);
        setBusySearching(true);
        taxSearch(year, {
            firstName,
            middleName,
            lastName,
            birthYear,
            size
        })
            .then((res) => {
                setSearchResult(res);
                setBusySearching(false);
            })
            .catch(() => {
                setErrorSearching(`Skattesøk er ikke tilgjenglig for ${year}.`);
                setBusySearching(false);
            });
    };

    return (
        <Page>
            <PageHeader icon="search" title="Skattesøk" subtitle="Skattelister" />
            <Row>
                <Col lg={17}>
                    <Row>
                        <Col span={24}>
                            <Card>
                                <CardTitle title="Søk på skattetall" />
                                <CardContent>
                                    <PersonSearchForm
                                        busy={busySearching}
                                        onSearch={handleSearch}
                                    />
                                </CardContent>
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Card>
                                <CardTitle title="Søkeresultat">
                                    {busySearching ? <Icon name="refresh" rotate /> : <Badge>{searchResult?.total}</Badge>}
                                </CardTitle>
                                <CardContent>
                                    {errorSearching ? (
                                        <Callout color="error">{errorSearching}</Callout>
                                    ) : busySearching ? (
                                        <Spinner />
                                    ) : (
                                        <ItemList
                                            busy={busySearching}
                                            emptyMessage={<Text opacity={50}>Ingen resultat</Text>}
                                        >
                                            {searchResult?.content.map((person, index) => {
                                                    return (
                                                        <ItemList.Item
                                                            index={index}
                                                            key={person.id}
                                                            prepend={
                                                                <Badge color="primary" fill number>
                                                                    {index + 1}
                                                                </Badge>
                                                            }
                                                        >
                                                            <Text weight="medium">
                                                                {personFullname(person)}
                                                            </Text>
                                                            <Text opacity={80}>
                                                                , f. {person.birthYear}
                                                            </Text>
                                                            <Text opacity={80}>
                                                                , {person.postName}
                                                            </Text>
                                                            <Text size="small" opacity={40} block>
                                                                Inntekt: {person.income} - Formue:{" "}
                                                                {person.fortune} - Skatt:{" "}
                                                                {person.tax}
                                                            </Text>
                                                        </ItemList.Item>
                                                    );
                                                })}
                                        </ItemList>
                                    )}
                                </CardContent>
                            </Card>
                        </Col>
                    </Row>
                </Col>
                <Col lg={7}>
                    <Card>
                        <CardTitle title="Om søket" />
                        <CardContent>
                            <Paragraph>
                                Velg skatteåret du ønsker å søke i fra nedtrekksmenyen. Deretter
                                skriver du inn navnet du ønsker å søke på og trykker "Søk".
                            </Paragraph>
                            <Callout color="info">
                                Vi gjør oppmerksom på at TV 2 er pålagt å logge alle søk i
                                skattelistene i tilfelle kontroll.
                            </Callout>
                        </CardContent>
                    </Card>
                </Col>
            </Row>
        </Page>
    );
};
